let user: any = null;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((listener) => listener());

export const userStore = {
  get: (): any => user,
  set: (next: any) => {
    user = next;
    emit();
  },
  clear: () => {
    user = null;
    emit();
  },
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};
